import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'
import IconLink from 'components/Shared/IconLink/Index'

const Content = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  background: #FFFFFF;
  width: 200px;
`

const AbortButton = styled(IconLink)`
  position: absolute;
  right: 0;
  margin-top: 4px;
`

const ProgressText = styled.div`
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  color: ${colors.secondary60};
  margin-top: 6px;
  margin-bottom: 4px;
`

const ProgressLine = styled.div`
  background: ${colors.secondary95};
  width: 100%;
  height: 2px;
`

const ProgressLineBar = styled.div`
  background: ${colors.primary40};
  width: ${props => props.progressPercent}%;
  height: 100%;
  transition: 0.5s;
`

const ExportFileProgressBar = ({ currentPercent, onAbort }) => {
  const { t } = useTranslation()

  const progressText = t('exportFileProgressBar.progressText', { currentPercent })

  return (
    <Content>
      <ProgressText data-test='progress-text'>{progressText}</ProgressText>

      <AbortButton iconName='icon-abort-export-12' onClick={onAbort} />

      <ProgressLine>
        <ProgressLineBar progressPercent={currentPercent} />
      </ProgressLine>
    </Content>
  )
}

ExportFileProgressBar.propTypes = {
  currentPercent: PropTypes.number,
  onAbort: PropTypes.func,
}

export default ExportFileProgressBar
